/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SupplierDeliveryDTOFromJSON, SupplierDeliveryDTOToJSON, } from './SupplierDeliveryDTO';
import { WarehouseCreditOrderItemDTOFromJSON, WarehouseCreditOrderItemDTOToJSON, } from './WarehouseCreditOrderItemDTO';
import { WarehouseCreditFeeBreakdownDTOFromJSON, WarehouseCreditFeeBreakdownDTOToJSON, } from './WarehouseCreditFeeBreakdownDTO';
/**
 * @export
 */
export const WarehouseCreditPackageDTOPackageStatusEnum = {
    NotPurchased: 'NOT_PURCHASED',
    SubmittedToWh: 'SUBMITTED_TO_WH',
    GoingToWh: 'GOING_TO_WH',
    AtWh: 'AT_WH',
    AtWhPaymentPending: 'AT_WH_PAYMENT_PENDING',
    AtWhReturnLabelPending: 'AT_WH_RETURN_LABEL_PENDING',
    Returned: 'RETURNED',
    Shipped: 'SHIPPED',
    Delivered: 'DELIVERED',
    Disposed: 'DISPOSED'
};
/**
 * @export
 */
export const WarehouseCreditPackageDTOCostSourceEnum = {
    Manual: 'MANUAL',
    Actual: 'ACTUAL',
    Initial: 'INITIAL',
    NotComing: 'NOT_COMING',
    Estimated: 'ESTIMATED',
    Unknown: 'UNKNOWN'
};
/**
 * Check if a given object implements the WarehouseCreditPackageDTO interface.
 */
export function instanceOfWarehouseCreditPackageDTO(value) {
    return true;
}
export function WarehouseCreditPackageDTOFromJSON(json) {
    return WarehouseCreditPackageDTOFromJSONTyped(json, false);
}
export function WarehouseCreditPackageDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'warehousePackageId': json['warehousePackageId'] == null ? undefined : json['warehousePackageId'],
        'amazonOrderId': json['amazonOrderId'] == null ? undefined : json['amazonOrderId'],
        'marketplace': json['marketplace'] == null ? undefined : json['marketplace'],
        'buyerOrderId': json['buyerOrderId'] == null ? undefined : json['buyerOrderId'],
        'packageStatus': json['packageStatus'] == null ? undefined : json['packageStatus'],
        'payable': json['payable'] == null ? undefined : json['payable'],
        'shippinglotStatus': json['shippinglotStatus'] == null ? undefined : json['shippinglotStatus'],
        'shippinglotOrderId': json['shippinglotOrderId'] == null ? undefined : json['shippinglotOrderId'],
        'manualFulfillment': json['manualFulfillment'] == null ? undefined : json['manualFulfillment'],
        'shippinglotWarehouse': json['shippinglotWarehouse'] == null ? undefined : json['shippinglotWarehouse'],
        'carrierName': json['carrierName'] == null ? undefined : json['carrierName'],
        'carrierService': json['carrierService'] == null ? undefined : json['carrierService'],
        'costUsd': json['costUsd'] == null ? undefined : json['costUsd'],
        'costSource': json['costSource'] == null ? undefined : json['costSource'],
        'shippinglotShippingCost': json['shippinglotShippingCost'] == null ? undefined : json['shippinglotShippingCost'],
        'shippinglotShippingCurrency': json['shippinglotShippingCurrency'] == null ? undefined : json['shippinglotShippingCurrency'],
        'fees': json['fees'] == null ? undefined : WarehouseCreditFeeBreakdownDTOFromJSON(json['fees']),
        'purchaseConfirmedAt': json['purchaseConfirmedAt'] == null ? undefined : (new Date(json['purchaseConfirmedAt'])),
        'receivedAt': json['receivedAt'] == null ? undefined : (new Date(json['receivedAt'])),
        'shipmentHoldAt': json['shipmentHoldAt'] == null ? undefined : (new Date(json['shipmentHoldAt'])),
        'supplierDelivery': json['supplierDelivery'] == null ? undefined : SupplierDeliveryDTOFromJSON(json['supplierDelivery']),
        'orderItems': json['orderItems'] == null ? undefined : (json['orderItems'].map(WarehouseCreditOrderItemDTOFromJSON)),
    };
}
export function WarehouseCreditPackageDTOToJSON(json) {
    return WarehouseCreditPackageDTOToJSONTyped(json, false);
}
export function WarehouseCreditPackageDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'warehousePackageId': value['warehousePackageId'],
        'amazonOrderId': value['amazonOrderId'],
        'marketplace': value['marketplace'],
        'buyerOrderId': value['buyerOrderId'],
        'packageStatus': value['packageStatus'],
        'payable': value['payable'],
        'shippinglotStatus': value['shippinglotStatus'],
        'shippinglotOrderId': value['shippinglotOrderId'],
        'manualFulfillment': value['manualFulfillment'],
        'shippinglotWarehouse': value['shippinglotWarehouse'],
        'carrierName': value['carrierName'],
        'carrierService': value['carrierService'],
        'costUsd': value['costUsd'],
        'costSource': value['costSource'],
        'shippinglotShippingCost': value['shippinglotShippingCost'],
        'shippinglotShippingCurrency': value['shippinglotShippingCurrency'],
        'fees': WarehouseCreditFeeBreakdownDTOToJSON(value['fees']),
        'purchaseConfirmedAt': value['purchaseConfirmedAt'] == null ? undefined : ((value['purchaseConfirmedAt']).toISOString()),
        'receivedAt': value['receivedAt'] == null ? undefined : ((value['receivedAt']).toISOString()),
        'shipmentHoldAt': value['shipmentHoldAt'] == null ? undefined : ((value['shipmentHoldAt']).toISOString()),
        'supplierDelivery': SupplierDeliveryDTOToJSON(value['supplierDelivery']),
        'orderItems': value['orderItems'] == null ? undefined : (value['orderItems'].map(WarehouseCreditOrderItemDTOToJSON)),
    };
}
